(() => {
  const closeOpenMobileMenu = () => {
    document.querySelectorAll('.mobile-nav[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  };

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeOpenMobileMenu();
  });

  document.querySelectorAll('.mobile-nav a').forEach((link) => {
    link.addEventListener('click', closeOpenMobileMenu);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addLabel = section.querySelector('[data-add-label]');
    const status = section.querySelector('[data-product-status]');

    if (!variantSelect || !addButton || !addLabel) return;

    const updateVariant = () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const isAvailable = option.dataset.available === 'true';
      const gateReady = addButton.dataset.gateReady === 'true';

      if (price && option.dataset.price) price.textContent = option.dataset.price;

      if (!gateReady) {
        addButton.disabled = true;
        addLabel.textContent = 'Personalizavimas ruošiamas';
        if (status) status.textContent = 'Pirkimas bus įjungtas patikrinus personalizavimą.';
        return;
      }

      addButton.disabled = !isAvailable;
      addLabel.textContent = isAvailable ? 'Pridėti į krepšelį' : 'Šiuo metu negalima užsakyti';
      if (status) {
        status.textContent = isAvailable
          ? `${option.textContent.trim()} pasirinkta.`
          : `${option.textContent.trim()} šiuo metu negalima užsakyti.`;
      }
    };

    variantSelect.addEventListener('change', updateVariant);
    updateVariant();
  });
})();
